<template>
  <session class="page-exchange-comp" v-if="show">
    <div class="bg" @click="Utils.exchangeDialogToggle(false)"/>
    <div class="login-comp-wrap">
      <div class="login-comp-l">
        <div class="login-form-block">
          <div class="blocktitle">
            <span class="main" :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('exchange_title')}}</span>
            <!-- <span class="sub" v-html="Utils.presetHtmlText(LOCAL('exchange_welcome_txt'))" /> -->
          </div>
          <div class="blockform-wrap">
            <div class="item-label" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('exchange_loginType_1_title') }}</div>
            <div class="item">
              <Icon name="key" size="18" />
              <div class="input-wrap"><input :placeholder="`${LOCAL('exchange_loginType_1_plsholder')}`" /></div>
              <div class="errortip" v-if="showAccountError">密钥错误，请重试</div>
            </div>
          </div>
        </div>
        <div class="blockform-wrap2">
          <div class="tipdesc">
            <label :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('exchange_description_title') }}</label>
            <span v-html="Utils.presetHtmlText(LOCAL('exchange_description_txt'))" />
          </div>
          <div class="submitbtn" @click="submitHandle"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('exchange_btn')}}</span></div>
        </div>
      </div>
      <div class="login-comp-r">
        <img class="logo" src="@/assets/images/logo-en.svg" v-if="!getLocalLangCode() || getLocalLangCode() == 'en'" />
        <img class="logo" src="@/assets/images/logo.svg" v-if="getLocalLangCode() == 'zh'" />
        <img class="logo" src="@/assets/images/logo-jp.svg" v-if="getLocalLangCode() == 'jp'" />
        <img class="logo" src="@/assets/images/logo-kr.svg" v-if="getLocalLangCode() == 'kr'" />
        <div class="close-wrap" @click="Utils.exchangeDialogToggle(false)"><icon name="close" /></div>
      </div>
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import Icon from '@/components/icon/index.vue';
  import EventBus from '@/assets/eventbus';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';
import Unit from '@/pages/plan/unit.vue';

  // 流出步骤
  const step = ref(1);  // 1 - 第一步；2 - 第二步

  const show = ref(false);
  onMounted(() => {
    EventBus.on('exchange_dialog_key', (data = null) => {
      console.log('data', data)
      show.value = data?.flag || false
      step.value = 1;
    });
  });

  /**
   * 第一步
   */
  // 入口列表
  const entrancesList = ref([]);
  const curEntrance = ref(null);
  const init = () => {
    entrancesList.value = [
      { title: LOCAL('login_loginType_1_title'), desc: LOCAL('login_loginType_1_desc'), icon: 'person', id: 'person' },
      { title: LOCAL('login_loginType_2_title'), desc: LOCAL('login_loginType_2_desc'), icon: 'enterprise', id: 'enterprise' },
      { title: LOCAL('login_loginType_3_title'), desc: LOCAL('login_loginType_3_desc'), icon: 'agent', id: 'agent' },
    ]
  }
  onMounted(() => {
    init()
  });

  const showAccountError = ref(false);
  const submitHandle = () => {
    showAccountError.value = true;
  }

  // 选择入口
  const selectEntrance = item => {
    curEntrance.value = item;
    step.value = 2;
  }

  /**
   * 第二步
   */
  const showPassword = ref(false)
</script>

<style scoped lang="less">
  @import "index.less";
</style>
